import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { viewRangeSelector } from 'common/selectors/integration';

class RelatedVideoTitleComponent extends React.Component {
  state = {
    shorten: true,
  };
  container = React.createRef();

  componentDidMount() {
    this.checkIfShorten();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.range === 'desktop_medium' ||
      this.props.range === 'desktop_large' ||
      prevProps.range === 'desktop_medium' ||
      prevProps.range === 'desktop_large'
    ) {
      if (this.props.range !== prevProps.range) {
        this.checkIfShorten();
      }
    }
  }

  checkIfShorten = () => {
    if (this.container.current) {
      let container = this.container.current.clientHeight;
      let title = this.container.current.childNodes[0].clientHeight;
      if (container > title) {
        this.setState({
          shorten: false,
        });
      }
    }
  };

  render() {
    return (
      <Link to={this.props.url}>
        <div ref={this.container} className={this.state.shorten ? 'ct-related-video-title__container--shorten' : ''}>
          <p className="ct-related-video-title__text">{this.props.title}</p>
        </div>
      </Link>
    );
  }
}

export const RelatedVideoTitle = connect(
  (state) => ({
    range: viewRangeSelector(state),
  }),
  {}
)((props) => <RelatedVideoTitleComponent {...props} />);
